import {
  AutoPaginationResponseBlock,
  OptimizerResponse
} from '../../types/api';
import {
  BorderingConfig,
  SeparatorConfig
} from '../../types/publisherPaginationSettings';
import { NOTICE_ELEMENT_PREFIX } from '../../pagination/constants';

const SEPARATOR_HEIGHT = 0.5;
const SEPARATOR_PREFIX = 'separator';

/**
 * 1. Sort all of the elements in read order (top to bottom *within columns*, left to right *within rows*)
 * 2. For each item, check if the previous item is a notice element. If it is, add a line element above the current item.
 */
export const addLines = <
  T extends Pick<AutoPaginationResponseBlock, 'elements'>
>(
  block: T,
  config: SeparatorConfig
) => {
  const newElements = [];
  for (const [idx, element] of block.elements.entries()) {
    newElements.push(element);

    if (!config.includeColumns?.includes(element.width)) {
      continue;
    }

    const elementsAbove = block.elements.filter(e => {
      if (e.id === element.id) return false;
      if (e.y >= element.y) return false;

      const elementRight = element.x + element.width;
      const eRight = e.x + e.width;

      if (e.x >= elementRight || eRight <= element.x) return false;

      return true;
    });
    const closestElementAbove = elementsAbove.sort((a, b) => b.y - a.y)[0];

    if (
      closestElementAbove &&
      closestElementAbove.id.includes(NOTICE_ELEMENT_PREFIX) &&
      element.id.includes(NOTICE_ELEMENT_PREFIX) &&
      config.includeColumns.includes(closestElementAbove.width)
    ) {
      const separatorY =
        (closestElementAbove.y + closestElementAbove.height + element.y) / 2;
      const separator = {
        id: `${SEPARATOR_PREFIX}-${idx}`,
        x: element.x,
        y: separatorY,
        width: element.width,
        height: SEPARATOR_HEIGHT
      };
      newElements.push(separator);
    }
  }
  return {
    ...block,
    elements: newElements
  };
};

export const addLinesBetweenAdjacentBlocks = (
  blocks: OptimizerResponse,
  config: SeparatorConfig
) => {
  return blocks.map(block => {
    const newBlock = addLines(block, config);
    return newBlock;
  });
};

export const addBorderBoxesToBlocks = (
  blocks: OptimizerResponse,
  bordering: BorderingConfig
) => {
  return blocks.map(block => {
    const newElements = block.elements.map(element => {
      if (!bordering.excludedColumns) {
        return element;
      }
      if (bordering.excludedColumns.includes(element.width)) {
        return element;
      }
      // Only add borders to notice elements
      if (!element.id.includes(NOTICE_ELEMENT_PREFIX)) {
        return element;
      }
      const newElement = {
        ...element,
        bordered: {
          thickness: bordering.thickness
        }
      };
      return newElement;
    });
    return {
      ...block,
      elements: newElements
    };
  });
};
